module.exports = __webpack_public_path__ + "static/media/boatyard.811f3667.svg";